import React from "react";
import ReactTable from "react-table";
import { Button, Col, Container, Row, TabPane, Input } from "reactstrap";
import QuotationTableFutureQuote from "../../../../Quotations/components/QuotationsTableFutureQuote";
import { FIRST_MONTH } from "../../../../Quotations/components/QuotationsTableFutureQuote/index";
import { getEmptyFilters } from "../../../../Quotations/utils";
import ModalFrame from "../../../../toolkit/modalFrame";
import { handleRequestError } from "../../../../utils/helpers";
import {
  errorNotification,
  infoNotification,
  successNotification
} from "../../../../utils/notifications";
import { getFutureChargesQuoteRequest } from "../../../actions/partners";
import { createMaintenanceChargesRequest } from "../../../actions/products";
import { Partner } from "../interfaces";

interface Props {
  partner: Partner;
  currentMembershipPartners: any[]; // Lista de los socios actuales de la MEMBRESIA-SOCIO
  currentMembershipConfiguration: any; //Configuración (entidad) actual de la MEMBRESIA-SOCIO
  invalidateStateValue: (fieldName: string, value: any) => void;
  refreshPartner: () => void;
}

interface State {
  isOpen: boolean;
  data: object;
  lastMonth: number;
  saving: boolean;
  selectedPartners: any[];
  partnersCheckedAll: boolean;
  futureChargesQuote: any[];
  loading: boolean;
}

let filters = getEmptyFilters();

const Quotations = props => {
  const handleSwitch = () => {
    props.toggle({
      clubId: filters.club,
      mantenimientoId: filters.mantenimiento,
      membresiaId: filters.membresia
    });
  };

  const onChangeMonth = month => {
    props.changeState(month);
  };

  return (
    <Container className="w-100 p-0 my-3">
      <Row>
        <Col lg={12} md={12} xs={12} className="w-100 p-0 m-0 test-class">
          <QuotationTableFutureQuote
            quotation={props.futureChargesQuote || {}}
            enableColumnEdition={true}
            onChangeMonth={onChangeMonth}
            keepIntegrantes={true}
          />
        </Col>
      </Row>

      <Row className="mt-3 mb-3">
        <Col className="pl-0">
          <Button onClick={handleSwitch}>Generar cargos</Button>
        </Col>
      </Row>
    </Container>
  );
};

//******************************Other Component**************************************
class TabPayments extends React.Component<Props, State> {
  state = {
    isOpen: false,
    data: null,
    lastMonth: FIRST_MONTH,
    saving: false,
    selectedPartners: [],
    partnersCheckedAll: false,
    futureChargesQuote: null,
    loading: false
  };

  personColumns = [
    {
      Header: () => (
        <div className="text-center">
          <Input
            id="checkAllPartners"
            type="checkbox"
            checked={this.state.partnersCheckedAll}
            onChange={this.checkAllPartners}
          />
        </div>
      ),
      id: 0,
      width: 80,
      Cell: row => {
        return (
          <div className="text-center">
            <Input
              type="checkbox"
              value={row.original.idPersona}
              checked={this.isPartnerChecked(row.original.idPersona)}
              onChange={this.onPartnercheckedChanged}
            />
          </div>
        );
      }
    },
    {
      Header: "Nombre",
      accessor: "nombrePersona"
    },
    { Header: "Tipo Integrante", accessor: "tipoSocio" },
    { Header: "Estatus", accessor: "estatus" }
  ];

  clearState = () => {
    this.setState({
      isOpen: false,
      data: null,
      lastMonth: FIRST_MONTH,
      saving: false,
      selectedPartners: [],
      partnersCheckedAll: false,
      futureChargesQuote: null,
      loading: false
    });
  };

  confirm = () => {
    const { partner } = this.props;
    const { futureChargesQuote, selectedPartners } = this.state;

    const startDate =
      futureChargesQuote.preciosFechaMantenimiento[0].fechaInicio;
    const finalDate =
      futureChargesQuote.preciosFechaMantenimiento[this.state.lastMonth - 1]
        .fechaFin;

    infoNotification("Creando cargo adelantado...");

    this.setState({ saving: true }, () => {
      createMaintenanceChargesRequest({
        startDate,
        finalDate,
        idMembresiaSocio: partner.idMembresiaSocio,
        personasIds: selectedPartners.join(",")
      })
        .then(() => {
          successNotification("Cargo adelantado generado correctamente");

          this.clearState();

          if (!!this.props.invalidateStateValue) {
            this.props.invalidateStateValue("movementsList", []);
          }

          this.props.refreshPartner();
        })
        .catch(handleRequestError);
    });
  };

  toggleModal = (data?: object) =>
    this.setState({ isOpen: !this.state.isOpen, data: data });

  changeState = month => {
    this.setState({ lastMonth: month });
  };

  onPartnercheckedChanged = event => {
    const target = event.target;
    const value = target.value;
    const selectedPartners =
      target.checked || false
        ? [...this.state.selectedPartners, parseInt(value)]
        : this.state.selectedPartners.filter(x => x != value);
    this.setState({ selectedPartners, futureChargesQuote: null });
  };

  isPartnerChecked = (partnerId): boolean => {
    return this.state.selectedPartners.includes(partnerId);
  };

  checkAllPartners = e => {
    this.setState({
      selectedPartners: e.target.checked
        ? (this.props.currentMembershipPartners || []).map(x => x.idPersona)
        : [],
      partnersCheckedAll: e.target.checked,
      futureChargesQuote: null
    });
  };

  getFutureChargesQuotationTabData = () => {
    const { idPublico, idClubBase } = this.props.partner;
    const { selectedPartners } = this.state;

    if ((selectedPartners || []).length <= 0) {
      errorNotification("Debe seleccionar al menos un integrante");
      return;
    }

    infoNotification("Consultando cargos adelantados...");
    this.setState({ loading: true, futureChargesQuote: null });

    getFutureChargesQuoteRequest(
      idPublico,
      idClubBase,
      selectedPartners.join(",")
    )
      .then(({ data }) => {
        this.setState({ futureChargesQuote: data, loading: false });
      })
      .catch(error => {
        this.setState({ loading: false, futureChargesQuote: null });
        handleRequestError(error);
      });
  };

  render() {
    return (
      <TabPane className="my-2" tabId="9">
        <ModalFrame
          title={"Generar cargos adelantados"}
          isOpen={this.state.isOpen}
          toggle={this.toggleModal}
        >
          <Container>
            <Row>
              <p className={`text-center w-100`}>
                Se generará el cargo adelantado para los meses seleccionados.
                <br />
                ¿Desea continuar?
              </p>
            </Row>
            <Row>
              <Col xs={6} className="text-center">
                <Button
                  onClick={this.confirm}
                  color="primary"
                  disabled={!!this.state.saving}
                >
                  Aceptar
                </Button>
              </Col>

              <Col xs={6} className="text-center">
                <Button color="secondary" onClick={this.toggleModal}>
                  Cancelar
                </Button>
              </Col>
            </Row>
          </Container>
        </ModalFrame>

        <Container className="p-0 m-0">
          <p className="primaryTitle w-100 mt-5">
            Paso 1: Seleccione los integrantes
          </p>
          <ReactTable
            manual
            data={this.props.currentMembershipPartners || []}
            columns={this.personColumns}
            className="w-100"
            sortable={false}
            showPagination={false}
            defaultPageSize={
              (this.props.currentMembershipPartners || []).length
            }
          />
          <Row className="mt-3 mb-3">
            <Col className="pl-0">
              <Button
                onClick={() => {
                  this.getFutureChargesQuotationTabData();
                }}
                disabled={!!this.state.loading}
              >
                Cotizar cargos
              </Button>
            </Col>
          </Row>

          {!!this.state.futureChargesQuote && (
            <>
              <p className="primaryTitle w-100 mt-5">
                Paso 2: Seleccione los meses a aplicar
              </p>

              <Row className="p-0 m-0">
                <Quotations
                  futureChargesQuote={this.state.futureChargesQuote}
                  toggle={this.toggleModal}
                  changeState={this.changeState}
                />
              </Row>
            </>
          )}
        </Container>
      </TabPane>
    );
  }
}
export default TabPayments;
